const kepzesek = [
  {
    id: 1,
    title: "Jazztánc",
    desc: "Mozgaskoordinációt fejlesztő, erősitő, lazitó tréning amely megalapozza a csoportos koreográfiához szükséges tudást (7-20 éves korig)",
    date: "Időpontról érdeklődni telefonon",
    trainer: "Kun Vera",
    phone: "+36704263943",
    email: "dcc.dancecitycenter@gmail.com",
    web: "",
    facebook: "https://www.facebook.com/dancecitycenter/",
    instagram: "https://www.instagram.com/dancecitycenter/",
    image: "/images/jazztanc.jpg",
  },
  {
    id: 2,
    title: "Ovis tánc",
    desc: "Táncos és játékos gimnasztika, és koreográfia (3-6 éves korig)",
    date: "Hétfő-Szerda 17:30-18:30",
    trainer: "Molnár Melinda",
    phone: "Kun Vera: +36704263943",
    email: "",
    web: "",
    facebook: "",
    instagram: "",
    image: "/images/ovistanc.jpg",
  },
  {
    id: 3,
    title: "Hiphop",
    desc: "Különböző streetdance stílusok, főleg hiphop zenére (gyerekeknek, fiatal felnőtteknek)",
    date: "Péntek és Szombat délután",
    trainer: "Murányi László",
    phone: "+36705782913",
    email: "",
    web: "",
    facebook:
      "https://www.facebook.com/Jamland-hivatalos-oldal-402146269801603/",
    instagram: "https://www.instagram.com/jamlandhiphop/",
    image: "/images/hiphop.jpg",
  },
  {
    id: 4,
    title: "Zumba",
    desc: "Latin táncokon, életérzésen alapuló fitness program, a táncon keresztül dinamikus, izgalmas élménnyé teszi az edzést. (gyerekeknek, felnőtteknek)",
    date: "Kedd 18:45-19:45, Csütörtök 19:30-20:30",
    trainer: "Ormándi Fanni",
    phone: "+36703606320 ",
    email: "",
    web: "http://zumbajucus.hu/",
    facebook: "https://www.facebook.com/juci.zumba",
    instagram: "https://www.instagram.com/zumbajucus",
    image: "/images/zumba.jpg",
    webname: "zumbajucus.hu",
  },
  {
    id: 5,
    title: "Jóga",
    desc: "Jóga ászanák, fitnesz elemek, erősítés, nyújtás- kellemes hangulatban -fiatal és idősebb korosztálynak egyaránt.",
    date: "Hétfő 18:45-19:45, Csütörtök 18:15-19:15",
    trainer: "Szűcs Bernadett",
    phone: "+36205494144 ",
    email: "flowwithbetti@gmail.com",
    web: "https://calendly.com/flowwithbetti/dynamic-flow-yoga-ora-1",
    facebook: "",
    instagram: "https://www.instagram.com/flowwithbetti",
    image: "/images/joga.jpg",
    webname: "Jelentkezés",
  },
  {
    id: 6,
    title: "Tanfolyamok",
    desc: "Angol és Magyar nyelvű tanfolyamok, előkészítők.",
    date: "",
    trainer: "",
    phone: "+36704157415 ",
    email: "ittismaskepp@gmail.com",
    web: "https://maskepp.eu",
    facebook: "https://www.facebook.com/ittis.eu",
    instagram: "",
    image: "/images/ittis.jpg",
    webname: "maskepp.eu",
  },
  {
    id: 7,
    title: "Wing Tsun Kung Fu",
    desc: "Önvédelem és kung fu oktatás 6 és 10 év közötti gyerekeknek.",
    date: "Hétfő-Szerda 17:00-18:00",
    trainer: "Si-Hing Balogh Tamás",
    phone: "+36205935475 ",
    email: "sihingtamas@gmail.com",
    web: "https://kungfuiskola.hu",
    facebook: "https://www.facebook.com/WTkungfu18gyerek",
    instagram: "",
    image: "/images/kungfu.jpg",
    webname: "kungfuiskola.hu",
  },
];

export default kepzesek;
